import { APP_ROUTES, formatQueryParams } from '@zorro/common-utils';
import {
  Stepper,
  type StepperStepProps,
} from '@zorro/design-system/v2/Stepper';
import { Stack } from '@zorro/web/design-system';
import { $enum } from 'ts-enum-util';

import {
  CarrierApplicationModalStepType,
  getCarrierApplicationModalStepConfig,
  getEmployeeTabRoute,
} from '.';
import { EmployeePageTabType } from '../../EmployeePage/EmployeePageContent';

type StepperLinkProps = StepperStepProps & {
  applicationStep: CarrierApplicationModalStepType;
  employerId: string;
  employeeId: string;
  onboardingPeriodId: string;
  benefitId?: string;
  tab: EmployeePageTabType;
};

const StepperLink = ({
  applicationStep,
  employerId,
  employeeId,
  onboardingPeriodId,
  benefitId,
  tab,
  ...props
}: StepperLinkProps) => {
  const { label } = getCarrierApplicationModalStepConfig(applicationStep);

  if (props.state === 'stepInactive') {
    return <Stepper.Step {...props} label={label} />;
  }

  const url = APP_ROUTES[getEmployeeTabRoute(tab)]({
    employerId,
    employeeId,
    onboardingPeriodId,
  });

  return (
    <Stepper.Link
      {...props}
      href={formatQueryParams(url, {
        step: applicationStep,
        ...(benefitId && { benefitId }),
      })}
      label={label}
    />
  );
};

type Props = {
  step: CarrierApplicationModalStepType;
  employerId: string;
  employeeId: string;
  onboardingPeriodId: string;
  benefitId?: string;
  tab: EmployeePageTabType;
};

export const CarrierApplicationModalStepper = ({
  step,
  employerId,
  employeeId,
  onboardingPeriodId,
  benefitId,
  tab,
}: Props) => {
  const { stepIndex } = getCarrierApplicationModalStepConfig(step);

  return (
    <Stack>
      <Stepper
        allowNextStepsSelect={false}
        active={stepIndex}
        wrap={false}
        size="sm"
      >
        {$enum(CarrierApplicationModalStepType)
          .getValues()
          .filter(
            (stepType) =>
              getCarrierApplicationModalStepConfig(stepType).withStepper
          )
          .map((applicationStep) => (
            <StepperLink
              key={applicationStep}
              applicationStep={applicationStep}
              employerId={employerId}
              employeeId={employeeId}
              onboardingPeriodId={onboardingPeriodId}
              benefitId={benefitId}
              tab={tab}
            />
          ))}
      </Stepper>
    </Stack>
  );
};
